import React from "react";
import Report from "../components/Report";
import Table from "../../../components/TableX";
import { useLazyQuery, API } from "../../../api";
import * as dateFns from "date-fns";

export default function ProductSalesReport() {
  const [getReport, { data, loading }] = useLazyQuery(
    API.GET_SALES_BY_PRODUCT,
    { fetchPolicy: "network-only" }
  );

  const [filters, setFilters] = React.useState({
    startDate: dateFns.startOfMonth(new Date()),
    endDate: dateFns.endOfMonth(new Date()),
  });

  React.useEffect(() => {
    getReport({ data: filters });
    // eslint-disable-next-line
  }, [filters]);

  const onDateRangeChange = ({ startDate, endDate }) => {
    setFilters({ ...filters, startDate, endDate });
  };

  const getData = () => {
    if (!data) return [];
    return data;
  };

  const columns = [
    {
      name: "code",
      label: "Item Code",
      options: { align: "center" },
    },
    {
      name: "description",
      label: "Description",
      options: { align: "left", width: 300 },
    },
    {
      name: "margin",
      label: "Margin",
      options: { align: "center" },
    },
    {
      name: "quantitySold",
      label: "Qty Invoiced",
      options: { align: "center" },
    },
    {
      name: "amount",
      label: "Total Amount",
      options: { align: "right", money: true, showTotal: true },
    },
  ];

  return (
    <Report
      title="Product Sales Report"
      useDateRange
      onDateRangeChange={onDateRangeChange}
      startDate={filters?.startDate}
      endDate={filters?.endDate}
      data={getData()}
      columns={columns}
    >
      <Table
        data={getData()}
        columns={columns}
        showTotals
        isLoading={loading}
      />
    </Report>
  );
}
